<template functional>
  <div style="align-content: center">
    <div
      class="mb-2"
      v-for="(group, index) in props.row.subgroups"
      :key="index"
    >
      <el-tag style="height: auto; color: black; width: 100%" type="info">
        <div class="row pt-2">
          <div class="col-12 col-sm-4 col-lg-2">
            <h6 class="mb-2">
              <strong
                ><translate-text keyTranslate="common_words.order" />:</strong
              >
            </h6>
            <template v-if="group.order != null">
              <p>
                {{ group.order }}
              </p>
            </template>
            <el-tag type="warning" v-else>
              <translate-text keyTranslate="common_words.no_assigned" />
            </el-tag>
          </div>
          <div class="col-12 col-sm-8 col-lg-5">
            <h6 class="mb-2">
              <strong
                ><translate-text keyTranslate="production.defect" />
                {{ index + 1 }}:</strong
              >
            </h6>
            <p>
              {{ group.name }}
            </p>
          </div>
          <div class="col-12 col-sm-8 col-lg-3">
            <h6 class="mb-2">
              <strong
                ><translate-text
                  keyTranslate="common_words.abbreviation"
                />:</strong
              >
            </h6>
            <template v-if="group.abreviature != null">
              <p>
                {{ group.abreviature }}
              </p>
            </template>
            <el-tag type="warning" v-else>
              <translate-text keyTranslate="common_words.no_assigned" />
            </el-tag>
          </div>
          <div class="col-12 col-sm-4 col-lg-2">
            <h6 class="mb-2">
              <strong
                ><translate-text
                  keyTranslate="common_words.deductible"
                />:</strong
              >
            </h6>
            <div v-if="group.discountable">
              <translate-text keyTranslate="common_words.yes" />
            </div>
            <div v-else>
              <translate-text keyTranslate="common_words.no" />
            </div>
          </div>
        </div>
      </el-tag>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DefectDataFormatter',
};
</script>
